<template>
  <SidebarLayout />
</template>

<script>
import SidebarLayout from './components/SidebarLayout.vue';

export default {
  name: 'App',
  components: {
    SidebarLayout,
  },
};
</script>

